/**
 *
 * BusinessAnalysis widget container
 * Fetch data & render main & detailed views as required
 *
 */
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import businessAnalysisModule from 'containers/App/data/endpoints/businessAnalysis';

import messages from './messages';
import { defaultLayout } from 'containers/widgets/Widget/propTypes';

import session from 'containers/App/session';
import Widget from 'containers/widgets/Widget/Widget';
import BusinessAnalysisContainer from './BusinessAnalysisContainer';

const BusinessAnalysisWrapper = ({ layout = defaultLayout, filters }) => {
    const dispatch = useDispatch();

    const propertyId = useSelector(session.selectors.selectSelectedPropertyId);
    const currency = useSelector(session.selectors.selectCurrency);
    const businessAnalysis = useSelector(businessAnalysisModule.selectors.selectState);

    const fetchData = () => {
        const { startDate, endDate } = filters;
        dispatch(businessAnalysisModule.actions.fetch(propertyId, startDate, endDate));
    };

    useEffect(() => {
        fetchData();
    }, [propertyId, filters]);

    const state = {
        fetching: businessAnalysis.fetching,
        error: businessAnalysis.error,
        fetched: businessAnalysis.fetched,
    };

    return (
        <Widget layout={layout} state={state} titleMessage={messages.title} retry={fetchData}>
            <BusinessAnalysisContainer filters={filters} currency={currency} data={businessAnalysis.data} />
        </Widget>
    );
};

export default BusinessAnalysisWrapper;
